import { Component, Input, OnChanges, SimpleChanges, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'text-block',
  templateUrl: './text-block.component.html',
  styleUrls: ['./text-block.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class TextBlockComponent implements OnChanges {
  @Input() textBlock: any;

  constructor() {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.textBlock && changes.textBlock.currentValue) {
      let textstring = this.textBlock.text.toString();
      textstring = textstring.replace(/<a/g, '<a class="link-text-block"');
      this.textBlock.text = textstring;
    }
  }

  getStyles() {
    const textblock = {
      'background-color': this.textBlock.background ? this.textBlock.background : null,
      color: this.textBlock.color ? this.textBlock.color : null,
    };
    return textblock;
  }
}
